function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.90903 12.9218L5.91586 12.0235C2.38839 8.84526 0.0595703 6.74915 0.0595703 4.17665C0.0595703 2.08054 1.71714 0.433594 3.82677 0.433594C5.01858 0.433594 6.16244 0.984844 6.90903 1.85596C7.65562 0.984844 8.79948 0.433594 9.99129 0.433594C12.1009 0.433594 13.7585 2.08054 13.7585 4.17665C13.7585 6.74915 11.4297 8.84526 7.9022 12.0303L6.90903 12.9218Z",
  fill: "white"
});
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.f72257ce.svg";
export { ForwardRef as ReactComponent };